// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { createElement, isValidElement, cloneElement } from '../../utils';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';
import Label from '../Label';

import '../../helpers/base.less';
import './Badge.less';

/**
 * `Badge` component.
 */
const Badge = ({ baseClassName, className, children, label, hidden, ...props }) => {
    if (children && !hidden) {
        if (!isValidElement(label)) {
            label = <Label intent="danger">{label}</Label>;
        }
        label = cloneElement(label, {
            className: classNames(`${baseClassName}__value`, label.props.className),
        });
    } else {
        label = null;
    }

    return (
        <div className={classNames(baseClassName, className)} {...props}>
            {children}
            {label}
        </div>
    );
};

Badge.propTypes = {
    /**
     * Display value. See [Label](#!/Label) for all props.
     */
    label: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element,
    ]).isRequired,
    /**
     * Set true for hide the badge.
     */
    hidden: PropTypes.bool,
    /**
     * Content of the `Badge`.
     */
    children: PropTypes.node,
    /**
     * @ignore
     */
    className: PropTypes.string,
    /**
     * @ignore
     */
    baseClassName: PropTypes.string,
};

Badge.defaultProps = {
    hidden: false,
    children: null,
    className: null,
    baseClassName: `${CLS_PREFIX}badge`,
};

export default Badge;



// WEBPACK FOOTER //
// ./components/Badge/Badge.js